define.alias("shared/components/shared/video-thumbnail-list", "settings/components/shared/video-thumbnail-list");